/**
 * 화면 선택(specs/037 FR-004) — 모바일 기기에서 고른 PC/모바일 화면. **탭 세션(sessionStorage) 동안만** 기억한다.
 * 같은 탭에서 워크스페이스를 나갔다 돌아오면 선택이 유지되고, 탭·브라우저를 닫은 뒤 새로 들어오면 다시 기기 판별(auto)부터 시작한다
 * — 한 번 고른 PC 화면이 영구히 남아 다음 방문에 당황하지 않게(개정 2026-10-24). 저장소 접근 실패는 persist 가 삼키고 auto 로 동작한다.
 */
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

/** `auto` = 기기 판별(모바일 기기면 모바일 화면으로 안내), `pc` = 모바일 기기에서도 PC 화면. */
export type UiMode = 'auto' | 'pc';

interface UiModeState {
  uiMode: UiMode;
  setUiMode: (mode: UiMode) => void;
}

export const useUiModeStore = create<UiModeState>()(
  persist(
    (set) => ({
      uiMode: 'auto',
      setUiMode: (mode) => set({ uiMode: mode }),
    }),
    {
      name: 'ws.uiMode',
      storage: createJSONStorage(() => sessionStorage),
      partialize: ({ uiMode }) => ({ uiMode }),
    },
  ),
);
